@if(!isSidebar) {
	<vb-title [title]="'Title_WebcastEventSettings' | translate"></vb-title>
}
<vb-centered-spinner [hidden]="!status.processing">
</vb-centered-spinner>

<edit-webcast-form [hidden]="status.processing || status.error" *ngIf="ready" [categories]="categories" [webcast]="webcast" [features]="mediaFeatures" [isSidebar]="isSidebar" [aiCreditsValid]="accountLicense.aiCreditsValid" (onSaveTemplate)="saveTemplate()" (onSubmit)="submit($event)" (onCancel)="onCancelled.emit()" (onTemplateSelected)="selectTemplate($event)" (sourceRestartInitiated)="sourceRestartInitiated.emit($event)" (switchStreamInitiated)="switchStreamInitiated.emit()">
</edit-webcast-form>

<div class="container-fluid">
	<div class="row" [hidden]="!(status.error)">
		<div class="col-xs-12">
			<div class="centered-copy">
				<div class="alert alert-danger">
					<span class="glyphicons circle_exclamation_mark">
					</span>
					&nbsp;{{ 'UnhandledError' | translate }}
				</div>
			</div>
		</div>
	</div>
</div>

<vb-confirmation-dialog #createSuccessDialog [title]="'Save' | translate" [message]="'Event_CreateSuccessDialog' | translate" [actionText]="'Ok' | translate">
</vb-confirmation-dialog>

<vb-confirmation-dialog #saveSuccessDialog [title]="'Save' | translate" [message]="'Event_SaveSuccessDialog' | translate" [actionText]="'Ok' | translate">
</vb-confirmation-dialog>
